angular.module(NgAppName).component('crSubscribe', {
	templateUrl: 'crSubscribe/crSubscribe.html',
	bindings: {
		url: '@',
		noTitle: '@',
		placeholder: '@'
	},
	controller: ['patterns', 'crResourcesService', function(patterns, crResourcesService) {
		var ctrl = this;
		this.email = '';
		this.patterns = patterns;
		this.isMobile = false;
		this.noTitle = this.noTitle ? true : false;
		// requires uuid because there can be multiple cr-subscribe instance on the same page
		this.uuid = Core.uuid();
		this.errorMessages = {
			required: 'This field is required.',
			email: 'Invalid Email.'
		};
		this.placeholderInput = this.placeholder || "Your email address";

		this.submitForm = function() {
			window.crRecaptcha.execute(() => { this.submitFormLogic(); }, "subscribe_to_newsletter");
		};

		this.submitFormLogic = function() {
			var data = {
				email: this.email,
				reCaptchaTokens: window.crRecaptcha.getTokens()
			};

			// remove the phone and the appointment if the user is working with an agent
			this.request = crResourcesService.post(this.url, data).then(
				(data) => {
					if (data.RPCFormSubscribeToNewsletter_FORMSUMMARY && data.RPCFormSubscribeToNewsletter_FORMSUMMARY[0].status === true) {
						this.success = true;
					} else {
						this.success = false;

						if (data["RPCFormSubscribeToNewsletter_email"]) {
							var error = data["RPCFormSubscribeToNewsletter_email"];
							if (error[0].indexOf("valid") > 0) {
								this.form.subscribe.email.$setValidity("pattern", false);
							} else {
								// may be another/generic message, but for now it's the same
								this.form.subscribe.email.$setValidity("pattern", false);
							}
						}
					}
				},
				(error) => {
					this.success = false;
				}
			);
		};
	}]
});
